import { render, staticRenderFns } from "./vioder.vue?vue&type=template&id=b1f4ee98&"
import script from "./vioder.vue?vue&type=script&lang=js&"
export * from "./vioder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports